module.exports = __webpack_public_path__ + "static/JOJOFinding.b0c7a901.png";